import { CloseOutlined } from '@ant-design/icons';
import { LinkButton } from '@framework/ui/components/button/LinkButton.tsx';
import clx from 'classnames';
import { useTranslation } from 'react-i18next';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import styled from 'styled-components';

const StyledLinkButton = styled(LinkButton)`
  &&& {
    &.is-mobile {
      width: 40px;
    }
  }
`;

export interface ISubmissionCancelButtonProps {}

/**
 * Pulsante per tornare all'elenco delle domande disponibile solo in Frontoffice
 */
export function SubmissionCancelButton(props: ISubmissionCancelButtonProps) {
  const { t } = useTranslation();
  const isMobile = useBreakpoint(down('md'));

  const showCancelSubmission = process.env.SHOW_CANCEL_SUBMISSION;
  if (showCancelSubmission !== 'true') return null;

  return (
    <StyledLinkButton
      className={clx({
        'is-mobile': isMobile,
      })}
      to={'/domande' as any}
      block={true}
      size="large"
      type="default"
      aria-label={t('form.back-to-inquiries', 'Annulla')}
    >
      {!isMobile ? (
        t('form.back-to-inquiries', 'Annulla')
      ) : (
        <CloseOutlined aria-hidden="true" />
      )}
    </StyledLinkButton>
  );
}
